import { postProcessPrimeData } from './prime-core.js';
import { calculateSelectWidth } from './prime-filter-utils.js';

/**
 * Schedule (match) filter handlers:
 *   seasons → tournaments → teams → load-more
 */

export function initScheduleFilters() {
    let oTheContainer;

    // Seasons
    $(document).on('change', '.prime-schedule .prime-filter-item select.prime-seasons', function() {
        const oTheSelected = $(this).find('option:selected');
        oTheContainer = oTheSelected.attr('data-selector-container');
        $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

        if ($('.prime-tournaments').length > 0) {
            $('.prime-tournaments')
                .empty()
                .append('<option value="0">' + $('.prime-tournaments').attr('data-label') + '</option>')
                .prop('selected', 'selected')
                .prop('disabled', 'disabled');
        }
        if ($('.prime-teams').length > 0) {
            $('.prime-teams')
                .empty()
                .append('<option value="0">' + $('.prime-teams').attr('data-label') + '</option>')
                .prop('selected', 'selected')
                .prop('disabled', 'disabled');
        }

        window.Ajax.prime_v2(
        {
            template   : oTheSelected.attr('data-selector-template'),
            id         : oTheSelected.val(),
            queryString: oTheSelected.attr('data-selector-query'),
            queryType  : oTheSelected.attr('data-query-type'),
            homeTeam   : oTheSelected.attr('data-home-team'),
            awayTeam   : oTheSelected.attr('data-away-team'),
            match      : oTheSelected.attr('data-match'),
            container  : oTheSelected.attr('data-selector-container'),
        },
        function(data) {
            $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
            $('.prime-schedule .load-more').attr('data-page', 2);

            oTheContainer = oTheSelected.attr('data-content-container');
            $(oTheContainer).empty().append(window.sTheLoader);
            $(oTheContainer).attr('data-content-template', oTheSelected.attr('data-content-template'));
            $(oTheContainer).attr('data-id', oTheSelected.val());
            $(oTheContainer).attr('data-content-query', oTheSelected.attr('data-content-query'));
            $(oTheContainer).attr('data-query-type', oTheSelected.attr('data-query-type'));
            $(oTheContainer).attr('data-content-container', oTheSelected.attr('data-content-container'));

            window.Ajax.prime_v2(
            {
                template   : oTheSelected.attr('data-content-template'),
                id         : oTheSelected.val(),
                queryString: oTheSelected.attr('data-content-query'),
                queryType  : oTheSelected.attr('data-query-type'),
                homeTeam   : oTheSelected.attr('data-home-team'),
                awayTeam   : oTheSelected.attr('data-away-team'),
                match      : oTheSelected.attr('data-match'),
                container  : oTheSelected.attr('data-content-container'),
            },
            function(data) {
                $(data.param.container).empty().append(data.markup);
                postProcessPrimeData($(data.param.container));
            },
            function(data) { window.showError(data); }
            );
        },
        function(data) { window.showError(data); }
        );
    });

    // Tournaments
    $(document).on('change', '.prime-schedule .prime-filter-item select.prime-tournaments', function() {
        const oTheSelected = $(this).find('option:selected');
        oTheContainer = oTheSelected.attr('data-selector-container');
        $(oTheContainer).empty().append('<option>&nbsp;...&nbsp;</option>');

        if ($('.prime-teams').length > 0) {
            $('.prime-teams')
                .empty()
                .append('<option value="0">' + $('.prime-teams').attr('data-label') + '</option>')
                .prop('disabled', 'disabled');
        }

        if (!$('body').hasClass('page-template-template-stats')) {
            $(this).css({ width: calculateSelectWidth($(this)) + 'px' });
        }

        window.Ajax.prime_v2(
        {
            template   : oTheSelected.attr('data-selector-template'),
            id         : oTheSelected.val(),
            queryString: oTheSelected.attr('data-selector-query'),
            queryType  : oTheSelected.attr('data-query-type'),
            homeTeam   : oTheSelected.attr('data-home-team'),
            awayTeam   : oTheSelected.attr('data-away-team'),
            match      : oTheSelected.attr('data-match'),
            container  : oTheSelected.attr('data-selector-container'),
        },
        function(data) {
            $(oTheContainer).empty().append(data.markup).prop('disabled', false).removeProp('disabled');
            $('.prime-schedule .load-more').attr('data-page', 2);

            oTheContainer = oTheSelected.attr('data-content-container');
            $(oTheContainer).empty().append(window.sTheLoader);
            $(oTheContainer).attr('data-content-template', oTheSelected.attr('data-content-template'));
            $(oTheContainer).attr('data-id', oTheSelected.val());
            $(oTheContainer).attr('data-content-query', oTheSelected.attr('data-content-query'));
            $(oTheContainer).attr('data-query-type', oTheSelected.attr('data-query-type'));
            $(oTheContainer).attr('data-content-container', oTheSelected.attr('data-content-container'));

            window.Ajax.prime_v2(
            {
                template   : oTheSelected.attr('data-content-template'),
                id         : oTheSelected.val(),
                queryString: oTheSelected.attr('data-content-query'),
                queryType  : oTheSelected.attr('data-query-type'),
                homeTeam   : oTheSelected.attr('data-home-team'),
                awayTeam   : oTheSelected.attr('data-away-team'),
                match      : oTheSelected.attr('data-match'),
                container  : oTheSelected.attr('data-content-container'),
            },
            function(data) {
                $(data.param.container).empty().append(data.markup);
                postProcessPrimeData($(data.param.container));
            },
            function(data) { window.showError(data); }
            );
        },
        function(data) { window.showError(data); }
        );
    });

    // Teams
    $(document).on('change', '.prime-schedule .prime-filter-item select.prime-teams', function() {
        const oTheSelected  = $(this).find('option:selected');
        const oTheContainer = oTheSelected.attr('data-content-container');
        $(oTheContainer).empty().append(window.sTheLoader);

        if (!$('body').hasClass('page-template-template-stats')) {
            $(this).css({ width: calculateSelectWidth($(this)) + 'px' });
        }

        $(oTheContainer).attr('data-content-template', oTheSelected.attr('data-content-template'));
        $(oTheContainer).attr('data-id', oTheSelected.val());
        $(oTheContainer).attr('data-content-query', oTheSelected.attr('data-content-query'));
        $(oTheContainer).attr('data-query-type', oTheSelected.attr('data-query-type'));
        $(oTheContainer).attr('data-content-container', oTheSelected.attr('data-content-container'));

        window.Ajax.prime_v2(
        {
            template   : oTheSelected.attr('data-content-template'),
            id         : oTheSelected.val(),
            queryString: oTheSelected.attr('data-content-query'),
            queryType  : oTheSelected.attr('data-query-type'),
            container  : oTheSelected.attr('data-content-container'),
        },
        function(data) {
            $(oTheContainer).empty().append(data.markup);
            $('.prime-schedule .load-more').attr('data-page', 2);
        },
        function(data) { window.showError(data); }
        );
    });

    // Load more
    $(document).on('click', '.prime-schedule .load-more', function() {
        const me            = $(this);
        const iThePage      = $(this).attr('data-page') * 1;
        const oTheContainer = $(this).closest('.row').find('.content-container.prime-data');

        me.prop('disabled', 'disabled');
        $(me).closest('div').append(window.sTheLoader);

        window.Ajax.prime_v2(
        {
            template   : oTheContainer.attr('data-content-template'),
            id         : oTheContainer.attr('data-id'),
            queryString: oTheContainer.attr('data-content-query') + '&page=' + iThePage,
            queryType  : oTheContainer.attr('data-query-type'),
            container  : oTheContainer.attr('data-content-container'),
        },
        function(data) {
            $(oTheContainer).append(data.markup);
            me.attr('data-page', iThePage + 1);
            me.prop('disabled', false).removeProp('disabled');
            $(me).closest('div').find('.loaderinfo').remove();
        },
        function(data) { window.showError(data); }
        );
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/common/prime-schedule-filters.js